import type { FC } from 'react';

import type { IconProps } from './type';

export const RewardFilledIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <svg
      fill="none"
      height={19}
      width={19}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.174 14.532h15V16h-15v-1.468Zm0-10.323 3.759 2.21 3.74-4.42 3.742 4.42 3.759-2.21v8.839h-15V4.209Z"
        fill="#B4BAE9"
      />
    </svg>
  );
};
